//swiperまるごとセット
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class Slider {
    constructor() {
        this.init();
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        const swiperDate = new Swiper('.js-swiper-date', {
            slidesPerView: 2,
            spaceBetween: 12,
            breakpoints: {
                835: {
                    slidesPerView: 4,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        const swiperTimetable = new Swiper('.js-swiper-timetable', {
            slidesPerView: 2,
            spaceBetween: 12,
            breakpoints: {
                835: {
                    slidesPerView: 4,
                },
            },
            controller: {
                control: swiperDate,
            },
        });

        // 双方向のコントロールを設定
        swiperDate.controller.control = swiperTimetable;
    }
}
